import React from "react";
import { default as WLink } from "@mui/material/Link";

function Link(props) {
  return <WLink {...props} />;
}

export default Link;
